import { Skeleton } from "@mui/material"

export const Productcardskeleton = () => {

    return (
        <div style={{ marginLeft: 2.5, marginRight: 2.5 }}>
            <Skeleton variant="rectangular" sx={{ height: 100, width: 100, marginBottom: 2 }} />
            <Skeleton variant="rectangular" sx={{ height: 10, width: 100, marginBottom: 1 }} />
            <Skeleton variant="rectangular" sx={{ height: 10, width: 80, marginBottom: 1 }} />
            <Skeleton variant="rectangular" sx={{ height: 10, width: 80, marginBottom: 2 }} />
            <Skeleton variant="rectangular" sx={{ height: 10, width: 100, borderRadius: 1, marginBottom: 2 }} />
        </div>
    )
}